@if (showMessage) {
  <div class="flex flex-col items-center justify-center">
    @for (message of messageInformations; track message) {
      <div class="message-banner" >
        <span [innerHTML]="message.description"></span>
      </div>
    }
  </div>
}

